import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../_metronic/helpers'
import { MyPolicy, PolicyData } from '../../auth/core/_models'
import { FamilyDetailsListWidget } from './FamilyDetailsListWidget'
import { useAuth } from '../../auth'
import { DashboardLinkWidget } from '../DashboardLinkWidget'

type Props = {
  show: boolean
  handleClose: () => void
  Title: string
  Email: string | undefined
  CrmUrl: string | undefined
  MyPolicy: MyPolicy | null
}

export const FamilyDetailsListModel: React.FC<Props> = ({ show, handleClose, Title, Email,CrmUrl, MyPolicy }) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [policyData, setPolicyData] = useState<PolicyData | null>(null)
  const currentUser = useAuth().currentUser

  useEffect(() => {
    if (show) {
      fetchPolicyData()
    }
  }, [show])

  const fetchPolicyData = async () => {
    setLoading(true)
    setError(null)
    try {
      
      const response = await fetch('https://etl.futurisk.in/webhook/getFamilyDetails', {
      
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(currentUser?.sessioncode ? { SessionCode: currentUser.sessioncode } : {}),
        },
        body: JSON.stringify({
          Email: Email,
          CorporateCode: MyPolicy?.Policy.CrmDbName,
        }),
      })
      if (!response.ok) {
        throw new Error('Failed to fetch family details')
      }
      const data: PolicyData = await response.json()
      setPolicyData(data)
    } catch (err: any) {
      setError(err.message || 'An unexpected error occurred')
    } finally {
      setLoading(false)
    }
  }

  const dissmissLocation = () => {
    handleClose()
  }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_test'
      data-backdrop='static'
      tabIndex={-1}
      role='model'
      show={show}
      dialogClassName='modal-lg modal-dialog-scrollable'
      aria-hidden='true'
      onHide={dissmissLocation}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>{Title}</h5>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={dissmissLocation}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? (
            <div className='text-center'>
              <div className='spinner-border text-primary' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className='text-danger text-center'>{error}</div>
          ) : policyData?.freezePolicy === 'false' ? (
            <>
              <div className='text-center mb-5'>
                Your Enrollment is open. Please click on "Enroll Family" to complete enrollment.
              </div>
              <div className='d-flex justify-content-center'>
                <div className='col-xl-4'>
                  <DashboardLinkWidget
                    className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border mx-5 mb-5'
                    avatar='crm.png'
                    title={'Enroll Family'}
                    description={currentUser?.CRMUrl?.Description || ''}
                    link={CrmUrl || '#'}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
            <FamilyDetailsListWidget className='' color='primary' PolicyData={policyData} />
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}

